import React, { useMemo } from 'react';
import { useGetStates } from '@area-restrita/api-client/endpoints/address/address.gen';

import Combobox, { ComboboxOption } from '@/components/Combobox';

interface IProps {
  value?: ComboboxOption;
  onChange?: (option?: ComboboxOption) => void;
  className?: string;
}

const UfSelector: React.FC<IProps> = ({ onChange, ...props }) => {
  const { data, isLoading } = useGetStates();

  const options = useMemo(
    () =>
      data?.map<ComboboxOption>((uf) => ({
        value: uf.id,
        label: uf.name,
      })) ?? [],
    [data],
  );

  return (
    <Combobox
      options={options}
      emptyText="Nenhum estado encontrado"
      placeholder="Selecione o estado..."
      searchPlaceholder="Pesquise o estado..."
      // showSearch
      isLoading={isLoading}
      onChangeValue={onChange}
      {...props}
    />
  );
};

export default UfSelector;
